module.exports = __webpack_public_path__ + "static/c.e815d5e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./res/TopGallery/c.jpg
// module id = 291
// module chunks = 114276838955818